import { get, post } from '@/utils/http.js'
// export const getRoleList = (data) => post('/role/findroleandMh',data);

// //新增角色
// export const addRole = (data) => post('/tr_api/v1/power/add-role',data);

// //修改角色
// export const editRole = (data) => post('/tr_api/v1/power/update-role',data);

// //查看角色详情
// export const getRole = (id) => get('/tr_api/v1/power/detail-role/'+id);
// 登录方法
export function login(username, password, code, uuid) {
    const data = {
        username,
        password,
        code,
        uuid
    }
    return post('/user/login',data)
}

// 获取用户详细信息
export const getInfo = () => get('/user/getInfo');

// export function getInfo() {
//     return request({
//         url: '/getInfo',
//         method: 'get'
//     })
// }

// 退出方法
export const logout = (data) => post('/user/logout',data);

// export function logout() {
//     return request({
//         url: '/logout',
//         method: 'post'
//     })
// }

// 获取验证码
// export function getCodeImg() {
//     return request({
//         url: '/captchaImage',
//         method: 'get'
//     })
// }